import React, { useState } from "react";
import { Button, CircularProgress } from "@mui/material";
import { retrieveItemByIdApi } from "../../../../components/api/ItemApiService";

const ItemButton = ({ row, setEditItem }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return; 
    setLoading(true);
    try {
      const itemData = await retrieveItemByIdApi(row?.offerItemId);
      if (!itemData) {
        alert("No data returned from the API.");
        return;
      }
      setEditItem({
        visible: true,
        data: itemData?.data,
        index: row?.index,
      });
      console.log(itemData);
    } catch (error) {
      console.error("Error retrieving item:", error);
    } finally {
      setLoading(false); 
    }
  };

  return (
    <Button
      sx={{
        minWidth: 0,
        padding: "2px 4px",
        fontSize: "0.8rem",
        lineHeight: 1,
      }}
      onClick={handleClick}
      variant="text"
      disabled={loading}
      startIcon={loading && <CircularProgress size={16} />}
    >
      {row?.offerItemId}
    </Button>
  );
};

export default ItemButton;
